class Copy {
    constructor() { }

    initCopy() {
        document.querySelectorAll('[data-copy]').forEach(el => {
            if (el._copyBound) return;
            el._copyBound = true;

            el.addEventListener('click', event => {
                event.preventDefault();
                if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;

                const text = el.dataset.copyText || el.dataset.copy;
                if (!text) return;

                this.copy(text).then(copied => {
                    const position = el.dataset.tooltipPosition || 'top';
                    this.tooltip(el, copied ? 'Copiado' : 'Não foi possível copiar', 3000, position);
                });
            });
        });
    }

    async copy(text) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            const activeElement = document.activeElement;
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            textarea.setAttribute('readonly', '');
            textarea.setAttribute('aria-hidden', 'true');

            try {
                document.body.appendChild(textarea);
                textarea.select();
                return document.execCommand('copy') === true;
            } catch {
                return false;
            } finally {
                textarea.remove();
                if (activeElement && typeof activeElement.focus === 'function') {
                    activeElement.focus({ preventScroll: true });
                }
            }
        }
    }

    tooltip(el, msg = 'Copiado', duration = 3000, position = 'top') {
        if (el._tooltip) el._tooltip.remove();
        if (el._tooltipTimeout) clearTimeout(el._tooltipTimeout);

        const computedPosition = window.getComputedStyle(el).position;
        if (computedPosition === 'static') {
            el.style.position = 'relative';
        }

        const tip = document.createElement('span');
        tip.setAttribute('role', 'status');
        tip.setAttribute('aria-live', 'polite');
        tip.setAttribute('aria-atomic', 'true');

        tip.style.cssText = `
            position: absolute;
            z-index: 10;
            padding: 6px 10px;
            border-radius: 12px;
            background: #000;
            color: #fff;
            font-size: 12px;
            white-space: nowrap;
            opacity: 0;
            pointer-events: none;
            transition: opacity .15s ease, transform .15s ease;
        `;

        const baseTransform = 'translate(-50%, -50%)';

        switch (position) {
            case 'right':
                tip.style.left = '100%';
                tip.style.top = '50%';
                tip.style.transform = 'translate(8px, -50%)';
                break;

            case 'left':
                tip.style.right = '100%';
                tip.style.top = '50%';
                tip.style.transform = 'translate(-8px, -50%)';
                break;

            case 'bottom':
                tip.style.left = '50%';
                tip.style.top = '100%';
                tip.style.transform = 'translate(-50%, 8px)';
                break;

            case 'top':
            default:
                tip.style.left = '50%';
                tip.style.bottom = '100%';
                tip.style.transform = 'translate(-50%, -8px)';
        }

        el.appendChild(tip);

        tip.offsetHeight;
        requestAnimationFrame(() => {
            tip.textContent = msg;
            tip.style.opacity = '1';
        });

        switch (position) {
            case 'right':
                tip.style.transform = 'translate(12px, -50%)';
                break;
            case 'left':
                tip.style.transform = 'translate(-12px, -50%)';
                break;
            case 'bottom':
                tip.style.transform = 'translate(-50%, 12px)';
                break;
            case 'top':
            default:
                tip.style.transform = 'translate(-50%, -12px)';
        }

        el._tooltip = tip;
        el._tooltipTimeout = setTimeout(() => {
            tip.style.opacity = '0';

            switch (position) {
                case 'right':
                    tip.style.transform = 'translate(4px, -50%)';
                    break;
                case 'left':
                    tip.style.transform = 'translate(-4px, -50%)';
                    break;
                case 'bottom':
                    tip.style.transform = 'translate(-50%, 4px)';
                    break;
                case 'top':
                default:
                    tip.style.transform = 'translate(-50%, -4px)';
            }

            setTimeout(() => {
                tip.remove();
                el._tooltip = null;
                el._tooltipTimeout = null;
            }, 200);
        }, duration);
    }
}

export default new Copy();
